// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application'

import AutoSubmitController from './auto_submit_controller'

import AvailabilityController from './availability_controller'

import BookingPageController from './booking_page_controller'

import BulkSelectController from './bulk_select_controller'

import CalendarReconnectController from './calendar_reconnect_controller'

import ClipboardController from './clipboard_controller'

import CopyFieldController from './copy_field_controller'

import DismissController from './dismiss_controller'

import DragController from './drag_controller'

import FormController from './form_controller'

import FormFieldsetController from './form_fieldset_controller'

import FormFillController from './form_fill_controller'

import FormHighlightController from './form_highlight_controller'

import FormOptionsKindsController from './form_options_kinds_controller'

import FormRepeatableFieldsController from './form_repeatable_fields_controller'

import GoogleAuthorizationController from './google_authorization_controller'

import GoogleCalendarConnectionController from './google_calendar_connection_controller'

import GoogleSignInController from './google_sign_in_controller'

import HighlightController from './highlight_controller'

import ImageFieldController from './image_field_controller'

import LoadingController from './loading_controller'

import MobileMenuController from './mobile_menu_controller'

import ModalController from './modal_controller'

import NavigationController from './navigation_controller'

import NavigationCounterController from './navigation_counter_controller'

import NavigationItemController from './navigation_item_controller'

import PaginateController from './paginate_controller'

import PreviewFrameController from './preview_frame_controller'

import RefreshController from './refresh_controller'

import RequestModeController from './request_mode_controller'

import ResizeController from './resize_controller'

import ResponsiveFrameController from './responsive_frame_controller'

import SelectAllController from './select_all_controller'

import SortableController from './sortable_controller'

import StaticSearchController from './static_search_controller'

import SubmitController from './submit_controller'

import SwapController from './swap_controller'

import TableViewCollectionController from './table_view_collection_controller'

import TableViewCollectionFieldController from './table_view_collection_field_controller'

import TableViewController from './table_view_controller'

import TabsController from './tabs_controller'

import TabsFieldController from './tabs_field_controller'

import TextareaGrowController from './textarea_grow_controller'

import ThreadController from './thread_controller'

import TransitionController from './transition_controller'

import TriggerController from './trigger_controller'

import VisibilityController from './visibility_controller'
application.register('auto-submit', AutoSubmitController)
application.register('availability', AvailabilityController)
application.register('booking-page', BookingPageController)
application.register('bulk-select', BulkSelectController)
application.register('calendar-reconnect', CalendarReconnectController)
application.register('clipboard', ClipboardController)
application.register('copy-field', CopyFieldController)
application.register('dismiss', DismissController)
application.register('drag', DragController)
application.register('form', FormController)
application.register('form-fieldset', FormFieldsetController)
application.register('form-fill', FormFillController)
application.register('form-highlight', FormHighlightController)
application.register('form-options-kinds', FormOptionsKindsController)
application.register('form-repeatable-fields', FormRepeatableFieldsController)
application.register('google-authorization', GoogleAuthorizationController)
application.register('google-calendar-connection', GoogleCalendarConnectionController)
application.register('google-sign-in', GoogleSignInController)
application.register('highlight', HighlightController)
application.register('image-field', ImageFieldController)
application.register('loading', LoadingController)
application.register('mobile-menu', MobileMenuController)
application.register('modal', ModalController)
application.register('navigation', NavigationController)
application.register('navigation-counter', NavigationCounterController)
application.register('navigation-item', NavigationItemController)
application.register('paginate', PaginateController)
application.register('preview-frame', PreviewFrameController)
application.register('refresh', RefreshController)
application.register('request-mode', RequestModeController)
application.register('resize', ResizeController)
application.register('responsive-frame', ResponsiveFrameController)
application.register('select-all', SelectAllController)
application.register('sortable', SortableController)
application.register('static-search', StaticSearchController)
application.register('submit', SubmitController)
application.register('swap', SwapController)
application.register('table-view-collection', TableViewCollectionController)
application.register('table-view-collection-field', TableViewCollectionFieldController)
application.register('table-view', TableViewController)
application.register('tabs', TabsController)
application.register('tabs-field', TabsFieldController)
application.register('textarea-grow', TextareaGrowController)
application.register('thread', ThreadController)
application.register('transition', TransitionController)
application.register('trigger', TriggerController)
application.register('visibility', VisibilityController)
